import type { PaginationMeta } from './common.dto'

export enum BulkImportStatus {
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export type OverrideCategory =
  | 'plan-benefit'
  | 'location'
  | 'smoker-rates'
  | 'service-area'
  | 'plans-rates'

export type ImportMode = 'UPSERT' | 'INSERT_ONLY'

export interface BulkImportSessionResponseDto {
  id: string
  overrideType: OverrideCategory
  importMode: ImportMode
  state: string | null
  originalFileName: string | null
  status: BulkImportStatus
  totalRows: number | null
  processedRows: number
  successCount: number | null
  errorCount: number | null
  createdCount: number | null
  updatedCount: number | null
  uploadedBy: string
  uploadedByName: string | null
  startedAt: string
  completedAt: string | null
  hasOriginalFile: boolean
  hasErrorsFile: boolean
  hasSuccessFile: boolean
  errorSummary: string | null
}

export interface ListBulkImportSessionsResponseDto {
  data: BulkImportSessionResponseDto[]
  meta: PaginationMeta
}

export interface BulkImportDownloadResponseDto {
  url: string
  expiresAt: string
}
